import { debounce } from "../utilities/debounce";
import { get, getAll } from "../utilities/querySelector";
const sliders = getAll( '[data-card-slider]' );

// Controls active state based on items in viewport
const activeItemsWatcher = new IntersectionObserver( assignActiveState, {
    root: document.body,
    rootMargin: '0px',
    threshold: 0.5
} );

const items = getAll( '.card-slider__item' );
items.forEach( item => {
    activeItemsWatcher.observe( item );
} );

sliders.forEach( async slider => {
    const container = slider.closest( '[data-slider-container]' );
    if ( !container ) return;
    const nav = get( '.card-slider__nav', container );
    const nextButton = get( '[data-slider-next]', container );
    const prevButton = get( '[data-slider-prev]', container );
    let cardWidth = getCardWidth( container );

    if ( !nextButton && !prevButton ) return;

    await new Promise( ( resolve ) => {
        setTimeout( () => resolve(), 500 );
    } );

    slider.addEventListener( 'scroll', debounce( setButtonState, 50 ) );
    setButtonState();

    nextButton?.addEventListener( 'click', next );
    prevButton?.addEventListener( 'click', prev );

    window.addEventListener( 'resize', debounce( setButtonState, 500 ) );
    window.addEventListener( 'resize', debounce( updateCardWidth, 500 ) );

    // let scrollsnap handle positioning correctly
    function next() {
        slider.scrollBy( { left: cardWidth } );
    }
    function prev() {
        slider.scrollBy( { left: -cardWidth } );
    }

    function updateCardWidth() {
        cardWidth = getCardWidth( container );
    }

    function setButtonState() {
        if ( nav ) {
            if ( slider.scrollWidth <= slider.clientWidth ) {
                nav.style.display = 'none';
                nav.parentElement.dataset.empty = true;
            } else {
                nav.style.removeProperty( 'display' );
                nav.parentElement.dataset.empty = false;
            }
        }
        if ( slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 10 ) {
            prevButton?.removeAttribute( 'disabled' );
            nextButton?.setAttribute( 'disabled', '' );
        } else if ( slider.scrollLeft === 0 ) {
            prevButton?.setAttribute( 'disabled', '' );
            nextButton?.removeAttribute( 'disabled' );
        } else {
            nextButton?.removeAttribute( 'disabled' );
            prevButton?.removeAttribute( 'disabled' );
        }
    }
} );

function getCardWidth( sliderContext ) {
    const card = get( '[data-card]', sliderContext );
    return card.offsetWidth;
}


// If item is in the viewport, set active else set inactive
function assignActiveState( entries ) {
    entries.forEach( entry => {
        entry.target.dataset.active = entry.isIntersecting;
    } );
}






